
define('template!webshopAttributesCategoryFiltersView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="toolbar">\n    <span class="toolbar-label">' +
((__t = ( _.i18n('attributeMatching.category', null, 'Category') )) == null ? '' : __t) +
'</span>\n    <div class="category-region"></div>\n    ' +
((__t = ( subHtml )) == null ? '' : __t) +
'\n</div>\n<div class="am-hint">' +
((__t = ( _.i18n('attributeMatching.categoryFiltersHint', null, 'The filters shown on the category page of the webshop, in this order. With none chosen, the page shows every filter its products carry (as before). The order is also the default columns of the category grid.') )) == null ? '' : __t) +
'</div>\n<div class="columns">\n    <div class="column">\n        <div class="column-title">' +
((__t = ( _.i18n('attributeMatching.categoryFiltersChosen', null, 'Filters of the category page') )) == null ? '' : __t) +
'</div>\n        <div class="chosen"></div>\n        <div class="chosen-tools">\n            <select class="add-attribute am-select"></select>\n            <span class="status am-hint"></span>\n            <span class="reset">' +
((__t = ( _.i18n('common.cancel', null, 'Cancel') )) == null ? '' : __t) +
'</span>\n            <span class="save off">' +
((__t = ( _.i18n('common.save', null, 'Save') )) == null ? '' : __t) +
'</span>\n        </div>\n    </div>\n    <div class="column">\n        <div class="column-title">\n            ' +
((__t = ( _.i18n('attributeMatching.categoryUsedAttributes', null, 'Attributes of the category\'s products') )) == null ? '' : __t) +
'\n            <span class="add-all-used" style="display: none"><i class="fa fa-plus"></i> ' +
((__t = ( _.i18n('attributeMatching.addAllUsedFilters', null, 'Add every filter used') )) == null ? '' : __t) +
'</span>\n        </div>\n        <div class="used"></div>\n    </div>\n</div>\n';

}
return __p
};});

